module.exports = __webpack_public_path__ + "img/horizontal_7_2_3009.ee543142.png";